export const CHANNEL = 'rxrooster.coverage.v1';

export function consumeFrameToken(
  location = window.location,
  history = window.history,
) {
  const fragment = new URLSearchParams(location.hash.slice(1));
  const token = fragment.get('token');
  if (token === null) return '';
  fragment.delete('token');
  history.replaceState(
    null,
    '',
    `${location.pathname}${location.search}${fragment.size ? `#${fragment}` : ''}`,
  );
  if (!/^frame_[A-Za-z0-9_-]{43}$/.test(token))
    throw new Error(
      'This coverage link is invalid. Open a new search from your scheduling system.',
    );
  return token;
}
export const EVENT_TYPES = [
  'ready',
  'loaded',
  'interest.created',
  'interest.updated',
  'resize',
  'error',
];

export function isCoverageEvent(event, frameWindow, origin, channel = CHANNEL) {
  return (
    event.source === frameWindow &&
    event.origin === origin &&
    event.data?.channel === channel &&
    [...EVENT_TYPES, 'selection.changed'].includes(event.data.type)
  );
}

// Installs the listener before navigation so even a cached frame's first
// ready event is received. New URLs initialize themselves; the ready/init
// exchange remains available for partners using the original token-free URL.
// onFrameEvent receives iframe protocol messages, not journey analytics events.
export function attachCoverageFrame(frame, session, onFrameEvent) {
  if (new URL(session.iframeUrl).origin !== session.iframeOrigin)
    throw new Error('Invalid iframe origin.');
  let initialized = false;
  const timeout = setTimeout(
    () =>
      onFrameEvent({
        type: 'error',
        message:
          'The coverage panel did not load. Check the approved origin and your frame-src policy, then retry.',
      }),
    20000,
  );
  const receive = (event) => {
    if (!isCoverageEvent(event, frame.contentWindow, session.iframeOrigin, session.protocol || CHANNEL))
      return;
    const data = event.data;
    if (data.type === 'ready' && session.token) {
      frame.contentWindow.postMessage(
        { channel: CHANNEL, type: 'init', token: session.token },
        session.iframeOrigin,
      );
      return;
    }
    if (data.type === 'loaded') {
      initialized = true;
      clearTimeout(timeout);
    }
    if (session.protocol !== 'rxrooster.coverage.v3' && data.type === 'resize' && Number.isFinite(data.height))
      frame.style.height = `${Math.max(480, Math.min(1800, data.height))}px`;
    // Request events contain opaque ids and status only.
    if (initialized || data.type === 'error') onFrameEvent(data);
  };
  window.addEventListener('message', receive);
  frame.src = session.iframeUrl;
  return () => {
    clearTimeout(timeout);
    window.removeEventListener('message', receive);
    frame.removeAttribute('src');
  };
}
